<div class="calendar-day">
  <div class="calendar-day__header">
    <div class="calendar-day__header-left">
      <button mat-icon-button (click)="onClickBack()" matTooltip="back to month">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h4 class="calendar-day__title">{{ selectedDate() | date: 'yyyy-MM-dd' }}</h4>
    </div>
    <div class="calendar-day__header-right">
      <button mat-icon-button (click)="onClickPrevious()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="onClickNext()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
  <div class="calendar-day__wrapper">
    @for (s of schedulePreview(); track s; let i = $index) {
      <ng-container
        *ngTemplateOutlet="
          item;
          context: {
            label: millisToString(s.millis),
            isSkipped: s.isSkipped,
            isTransmitted: s.isTransmitted,
          }
        "
      ></ng-container>
    }
  </div>
  @if (!schedulePreview()?.length) {
    <mat-error class="calendar-day__error">There is no fix!</mat-error>
  }
</div>

<ng-template #item let-label="label" let-isSkipped="isSkipped" let-isTransmitted="isTransmitted">
  <span
    class="calendar-day__item"
    [ngClass]="{ skip: isSkipped, active: !isSkipped, transmitted: isTransmitted }"
    [matTooltip]="getHourTooltip(label, isSkipped)"
    [attr.data-testid]="'calendar-day-' + label"
    >{{ label }}</span
  >
</ng-template>

@if (schedulePreview()?.length) {
  <div class="calendar-day__legend">
    <div class="calendar-day__legend-transmitted"></div>
    <span>Transmission</span>
    <div class="calendar-day__legend-fix"></div>
    <span>Fix</span>
    @if (scheduleService().config.hasSkipCount) {
      <div class="calendar-day__legend-skip"></div>
      <span>Skip</span>
    }
  </div>
}
